import { render, staticRenderFns } from "./proHeader.vue?vue&type=template&id=5b2b50d4&"
import script from "./proHeader.vue?vue&type=script&lang=js&"
export * from "./proHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports